import CustomDataTable from 'components/shared/CustomDataTable'
import { ISeoModel } from 'models/Seo.Model';
import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import CommonService from 'services/CommonService';
import { useNavigate } from 'react-router-dom';
import CustomLoader from 'components/Common/CustomLoader';
import UseDebounce from 'components/shared/UseDebounce';
import { useTypedSelector } from 'features/reduxhooks/ReduxHooks';
import Paginate from 'components/Common/Paginate';

function SEODashboard() {
    const navigate = useNavigate();
    const [dashbord, setDashbord] = useState<Array<ISeoModel>>([]);
    const [recordsCount, setRecordsCount] = useState<number>(0);
    const [searchText, setSearchText] = useState<any>();
    const [showLoading, setShowLoading] = useState(true);
    const debouncedSearch = UseDebounce(searchText, 1000);

    const [rowsPerPage] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const [offsetStart, setOffsetStart] = useState<number>(0);

    const columns = useMemo(() => [
        {
            Header: 'Page Name',
            accessor: 'PageName',
            Filter: true,
            sortable: true,
            width: '20%'
        },
        {
            Header: 'Title',
            accessor: 'Title',
            Filter: true,
            sortable: true,
            width: "60%",
        },
    ], []);

    const data: any = {
        OffsetStart: offsetStart,
        RowsPerPage: rowsPerPage,
        SortOrder: '',
        SortOrderColumn: '',
        SearchText: debouncedSearch,
    }

    const onColumnSortChange = (id, order) => {
        return true
    }

    const editHandler = (val: any) => {
        setShowLoading(true);
        navigate(`/seo-edit/${val.Id}?${val.PageName}`);
        setShowLoading(false);
    }

    const handleSearchChange = (e) => {
        setSearchText(e.target.value)

    }

    useEffect(() => {
        const getSeoList = () => {
            CommonService.post("SEO", "GetSEOList", data).then((res: any) => {
                if (res.status === 200) {
                    setShowLoading(false);
                    setDashbord(res.data.Items);
                    setRecordsCount(res.data.RecordsCount);
                }
            }).catch((e: string) => {
                console.log(e);
            });
        }
        getSeoList();
    }, [debouncedSearch, offsetStart, rowsPerPage])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <CustomLoader isOpen={showLoading} />
                    <div>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>SEO LISTS</h5>
                    </div>
                    <Card>
                        <CardBody>
                            <Row>
                                <Col xl={6}>
                                    <div className="search-box mb-2 me-2">
                                        <div className="position-relative">
                                            <input
                                                type="search"
                                                name='search'
                                                className="form-control bg-light border-light rounded"
                                                placeholder="Search Page..."
                                                value={searchText}
                                                onChange={handleSearchChange}
                                            />
                                            <i className="bx bx-search-alt search-icon"></i>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <CustomDataTable
                                columns={columns}
                                data={dashbord}
                                customPageSize={dashbord?.length}
                                isPagination={false}
                                isGlobalFilter={false}
                                perPageData={dashbord?.length}
                                isActionEdit={true}
                                isActionDelete={false}
                                editHandler={editHandler}
                                canShowButton1={false}
                                canShowButton2={false}
                                searchHandler={undefined}
                                onColumnSortChange={onColumnSortChange}
                                deleteHandler={undefined}
                                createHandler={undefined}
                                path={''}
                                firstBtnName={'Create'}
                                pageSize={rowsPerPage}
                                sortOrder={undefined}
                                rowsPerPage={rowsPerPage}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                offsetStart={offsetStart}
                                setOffsetStart={setOffsetStart} />
                        </CardBody>
                    </Card>
                    {recordsCount > rowsPerPage && <Paginate recordsCount={recordsCount} rowName={'Brands'} rowsPerPage={rowsPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} offsetStart={offsetStart} setOffsetStart={setOffsetStart} />}
                </Container>
            </div>
        </React.Fragment>
    )
}

export default SEODashboard
